import {
  CompanySearch,
  PageHeader,
  AppLayout,
  WhatToDoNext,
  Container,
} from '@components'
import { queryCompanyFilters, queryCompanyList } from '@queries'
import { ICompany, ICompanyFilters, ICompanyWithDeal, IDeal } from '@types'
import { GetStaticProps, NextPage } from 'next'
import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/auth'
import { getGraphQLData } from '../../database/graphQL/apollo'
import axios from 'axios'
import { Mixpanel } from '@utils'
import { NextSeo } from 'next-seo'

export const getStaticProps: GetStaticProps = async () => {
  const response = await getGraphQLData<{ allCompanies: ICompany[] }>(
    queryCompanyList,
  )

  const filterResponse = await getGraphQLData<{
    allRegions: any[]
    allSectors: any[]
    allStages: any[]
  }>(queryCompanyFilters)

  const filters: any = {
    sectorOptions: [],
    regionOptions: [],
    stageOptions: [],
    stages: [
      {
        value: 'Early',
        text: 'Early',
      },
      {
        value: 'Growth',
        text: 'Growth',
      },
      {
        value: 'Late',
        text: 'Late',
      },
      {
        value: 'Pre-IPO',
        text: 'Pre-IPO',
      },
    ],
  }

  filters.regionOptions =
    filterResponse?.allRegions.map((opt: any) => ({
      value: opt.name,
      text: opt.name,
    })) || null
  filters.sectorOptions =
    filterResponse?.allSectors.map((opt: any) => ({
      value: opt.name,
      text: opt.name,
    })) || null
  filters.stageOptions =
    filterResponse?.allStages.map((opt: any) => ({
      value: opt.name,
      text: opt.name,
    })) || null

  return {
    props: { companies: response?.allCompanies || null, filters },
    revalidate: 10,
  }
}

const Companies: NextPage<{
  companies: ICompany[]
  filters: ICompanyFilters
}> = ({ companies, filters }) => {
  const [companiesWithMainDeal, setCompaniesWithMainDeal] = useState<
    ICompanyWithDeal[]
  >(companies ? [...companies] : [])
  const authContext = useContext(AuthContext)

  useEffect(() => {
    axios
      .get(process.env.NEXT_PUBLIC_API_URL + '/companies/mainDeals')
      .then(response => {
        const companyDeals = response.data
        const _companies: ICompany[] = companies.map(
          (company: ICompanyWithDeal) => {
            const companyWithDeal = companyDeals.find(
              (companyWithDeal: ICompanyWithDeal) =>
                companyWithDeal.slug === company.slug,
            )
            if (companyWithDeal) {
              const deal = companyWithDeal.deals[0] as IDeal

              company = {
                ...company,
                ...deal,
              }
            }
            return company
          },
        )
        setCompaniesWithMainDeal([..._companies])
      })
      .catch(err => {
        console.log('err', err)
      })
  }, [authContext])

  useEffect(() => {
    Mixpanel.track('Visited-opportunities')
  }, [])

  return (
    <AppLayout>
      <Container>
        <NextSeo
          title="Investment Opportunities"
          description="MarketX is a one-stop shop for over 300 family offices, funds, and
        high net worth individuals to access high growth investment
        opportunities."
          canonical="https://www.marketxventures.com/invest/companies"
          openGraph={{
            title: 'Investment Opportunities | MarketX Ventures',
            url: 'https://www.marketxventures.com/invest/companies',
          }}
        />

        <PageHeader
          title={'Direct Investments'}
          extra="Browse, search or filter the following opportunities, then click on any
      one to learn and to invest."
        />
        <CompanySearch allCompanies={companiesWithMainDeal} filters={filters} />
      </Container>
    </AppLayout>
  )
}

export default Companies
